export const MANUAL = 0
export const AUTO = 1
export const ALPHA = 2
export const roll_type = [
    { value: '0', label: 'Manual' , translate: "classes:section.add.rollNoType.manual"},
    { value: '1', label: 'Auto Increment', translate: "classes:section.add.rollNoType.autoIncrement"},
    { value: '2', label: 'Alphabetically', translate: "classes:section.add.rollNoType.alphabetically"},
]
